<script setup>
import { computed, toRefs } from 'vue';

const props = defineProps({
  messageType: {
    type: String,
    default: '',
  },
  previewType: {
    type: String,
    default: '',
  },
});

const {
  messageType,
  previewType,
} = toRefs(props);

const className = computed(() => {
  if (previewType.value === 'fallback') {
    return '';
  }

  switch (messageType.value) {
    case '':
    case 'FRIENDTALK_TEXT':
    case 'FRIENDTALK_IMAGE':
    case 'FRIENDTALK_WIDE_IMAGE':
    case 'FRIENDTALK_WIDE_ITEM_LIST':
    case 'FRIENDTALK_COMMERCE':
    case 'FRIENDTALK_CAROUSEL_FEED':
    case 'FRIENDTALK_CAROUSEL_COMMERCE':
    case 'FRIENDTALK_PREMIUM_VIDEO':
    case 'ALIMTALK_BA':
    case 'ALIMTALK_EX':
    case 'ALIMTALK_AD':
    case 'ALIMTALK_MI':
    case 'BRANDTALK_TEXT':
    case 'BRANDTALK_IMAGE':
    case 'BRANDTALK_WIDE_IMAGE':
    case 'BRANDTALK_WIDE_ITEM_LIST':
    case 'BRANDTALK_CAROUSEL_FEED':
    case 'BRANDTALK_CAROUSEL_COMMERCE':
    case 'BRANDTALK_COMMERCE':
    case 'BRANDTALK_PREMIUM_VIDEO':
      return 'kakao';
    default:
      return '';
  }
});

</script>
<template>
  <div
    class="android-mockup"
    :class="className"
  >
    <span class="punch-hole"></span>
    <span class="right-button"></span>
    <span class="right-button2"></span>
    <slot />
  </div>
</template>
